import { useEffect, useState } from 'react'
import { Download, ExternalLink, X } from 'lucide-react'

function isiOSSafari() {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.includes('Mac') && navigator.maxTouchPoints > 1)
  const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|FxiOS/.test(ua)
  return isIOS && isSafari
}

export default function RoomScanPreviewModal({ scan, onClose }) {
  const [showAR, setShowAR] = useState(false)

  useEffect(() => {
    setShowAR(isiOSSafari())
  }, [])

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose?.() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  if (!scan) return null

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal room-scan-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="room-scan-modal-title"
      >
        <div className="modal__header">
          <h2 id="room-scan-modal-title" className="modal__title">{scan.name}</h2>
          <button type="button" className="icon-btn" aria-label="Close" onClick={onClose}>
            <X size={16} />
          </button>
        </div>

        <div className="room-scan-modal__panes">
          <figure className="room-scan-modal__pane">
            <figcaption>Floor plan</figcaption>
            <div className="room-scan-modal__pane-frame">
              {scan.floorplan_png_url ? (
                <img src={scan.floorplan_png_url} alt="Top-down floor plan" />
              ) : (
                <div className="room-scan-modal__placeholder">No floor plan rendered</div>
              )}
            </div>
          </figure>
          <figure className="room-scan-modal__pane">
            <figcaption>3D preview</figcaption>
            <div className="room-scan-modal__pane-frame">
              {showAR && scan.download_url ? (
                <model-viewer
                  ios-src={scan.download_url}
                  ar=""
                  ar-modes="quick-look"
                  camera-controls=""
                  auto-rotate=""
                  style={{ width: '100%', height: '100%' }}
                />
              ) : scan.thumbnail_url ? (
                <img src={scan.thumbnail_url} alt="3D thumbnail" />
              ) : (
                <div className="room-scan-modal__placeholder">No thumbnail captured</div>
              )}
            </div>
          </figure>
        </div>

        <div className="room-scan-modal__meta">
          <dl>
            <div><dt>Captured</dt><dd>{scan.captured_at ? new Date(scan.captured_at).toLocaleString() : '—'}</dd></div>
            <div><dt>Walls</dt><dd>{scan.wall_count ?? 0}</dd></div>
            <div><dt>Doors</dt><dd>{scan.door_count ?? 0}</dd></div>
            <div><dt>Windows</dt><dd>{scan.window_count ?? 0}</dd></div>
            <div><dt>Objects</dt><dd>{scan.object_count ?? 0}</dd></div>
          </dl>
        </div>

        <div className="modal__actions">
          {scan.download_url && (
            <a className="btn" href={scan.download_url} download>
              <Download size={14} /> Download USDZ
            </a>
          )}
          {scan.download_url && (
            <a
              className="btn btn--primary"
              href={scan.download_url}
              target="_blank"
              rel="noreferrer"
            >
              <ExternalLink size={14} /> Open in new tab
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
